import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { CheckboxTableService } from "../../services/checkbox-table.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-checkbox-all-table",
  templateUrl: "./checkbox-all-table.component.html",
  styleUrls: ["./checkbox-all-table.component.scss", "../checkbox-table/checkbox-table.component.scss"],
})
export class CheckboxAllTableComponent implements OnInit, OnDestroy {
  @Input() selectedRowCount!: number;
  @Input() rowCount!: number;

  state = false;
  subs: Subscription[] = [];

  constructor(private checkboxTableService: CheckboxTableService) {}

  // TODO найти решение для того что бы избавиться от setTimeout
  ngOnInit() {
    this.subs.push(
      this.checkboxTableService.compareCount$.subscribe({
        next: () => {
          setTimeout(() => {
            if (this.rowCount > 0) {
              this.state = this.selectedRowCount === this.rowCount;
            } else {
              this.state = false;
            }
          }, 0);
        },
      })
    );
  }

  ngOnDestroy() {
    this.subs.forEach((item) => item.unsubscribe());
  }

  checkChange() {
    this.checkboxTableService.checkboxSelectAll$.next(this.state);
  }
}
